import { createRouter, createWebHistory } from 'vue-router'
import CountryCodePage from '../views/CountryCodePage.vue'
import TimeToolsPage from '../views/TimeToolsPage.vue'
import CalendarPage from '../views/CalendarPage.vue'
import ConvertPage from '../views/ConvertPage.vue'
import CitiesPage from '../views/CitiesPage.vue'
import CityDetailPage from '../views/CityDetailPage.vue'
import TimeCalculatorPage from '../views/TimeCalculatorPage.vue'
import ClockPage from '../views/ClockPage.vue'
import AlarmPage from '../views/AlarmPage.vue'
import AgePage from '../views/AgePage.vue'
import HolidaysPage from '../views/HolidaysPage.vue'
import UnixPage from '../views/UnixPage.vue'

const routes = [
  { path: '/', name: 'home', component: CountryCodePage },
  { path: '/tools', name: 'tools', component: TimeToolsPage },
  { path: '/calendar', name: 'calendar', component: CalendarPage },
  { path: '/convert', name: 'convert', component: ConvertPage },
  { path: '/cities', name: 'cities', component: CitiesPage },
  { path: '/city/:name', name: 'city-detail', component: CityDetailPage, props: true },
  { path: '/calculator', name: 'calculator', component: TimeCalculatorPage },
  { path: '/clock', name: 'clock', component: ClockPage },
  { path: '/alarm', name: 'alarm', component: AlarmPage },
  { path: '/age', name: 'age', component: AgePage },
  { path: '/holidays', name: 'holidays', component: HolidaysPage },
  { path: '/unix', name: 'unix', component: UnixPage }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
